'use client';

import React from 'react';
import { getPageSection, PageSections } from '@/pageBuilder';

const Membership = ({ data, stripeLink }: { data: any[], stripeLink: string }) => (
  <>
    {data.map((section: any) => (
      <React.Fragment key={section.__component}>
        {getPageSection({
          name: section.__component as PageSections,
          props: {
            data: section,
            ...(section.__component === 'membership.introductory-offer-section' ? { stripeLink } : {}),
          },
        })}
      </React.Fragment>
    ))}
  </>
);

export default Membership;
